import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { initFlowbite } from 'flowbite';

@Component({
  selector: 'app-root',
  template: `
  @if (shouldShowHeader()) {
    <app-header>
    <router-outlet />
    </app-header> 
  } @else {
    <router-outlet />
  }
  `
})
export class AppComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    initFlowbite();
  }

  shouldShowHeader(): boolean {
    return this.router.url !== `/`;
  }
}
